import { schema } from 'normalizr';
import employee from './employee';

const client = new schema.Entity('clients', {
  employees: [employee]
});

export default client;
